import Vue from 'vue';

export default {
  eventBus: new Vue(),
};



// WEBPACK FOOTER //
// ./src/modules/IntentEngine/_utils/eventBus.js